"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "ogliastro-cilento": {
    "fbb04116": [{
      "hkey": "5afe9ee2",
      "slug": "ogliastro-cilento",
      "name": "Ogliastro Cilento",
      "primary": true,
      "skipSearch": false
    }],
    "eredita": [{
      "hkey": "5afe9ee2",
      "slug": "ogliastro-cilento",
      "name": "Ogliastro Cilento",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c1fa7471": [{
      "hkey": "cf81f88d",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "ogliastro-cilento": [{
      "hkey": "cf81f88d",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;